import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/security/adminuser/configuration/securityChanges/filter'; // Importing Filters component
import Table from 'views/security/adminuser/configuration/securityChanges/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from devConfig
                },
            ],
        };
        const left = {
            // Left side configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            view: 'label', // Label displaying the title
                            label: _('Seguridad Cambios'), // Translated title
                            width: 150,
                        },
                    ],
                },
                Table, // Including the Table component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        if (
            !devConfig.getPermAction(
                // Check permissions for the menu action
                'AdminuserConfigurationSecurityChangesMenu',
                'Menu',
            )
        ) {
            this.show('./security.adminuser.configuration.qrgoogle'); // Redirect if no permission
        } else {
            return {
                // Return the main configuration object
                type: 'clean',
                view: 'form',
                scroll: true,
                cols: [left], // Include the left configuration
            };
        }
    }
}

// FILE DOCUMENTED
